package com.merkost.handpass.sharedweb.theme

enum class ThemeMode { LIGHT, DARK, SYSTEM }
